import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import * as paths from "router/const";

interface RedirectToLoginProps {
  isLogin: boolean;
}

/**
 * 없는 url중 로그인이 되어있으면 메인, 아니면 로그인 페이지로 리다이렉트
 * @returns
 */
export const RedirectToLogin = ({ isLogin }: RedirectToLoginProps) => {
  const navigate = useNavigate();

  useEffect(() => {
    isLogin ? navigate(paths.ROUTE_ROOT) : navigate(paths.ROUTE_LOGIN);
  });

  return null;
};
